import React from 'react';
import {
  getArticleUrl,
  Locale,
  NewsArticleUrlFields,
} from '../../../lib/selectTranslatedArticleLinks';

interface HrefLangTagProperties {
  locale: Locale;
  article: NewsArticleUrlFields;
  origin: string;
}

const HrefLangTag = ({
  locale,
  article,
  origin,
}: HrefLangTagProperties) => (
  <link
    rel="alternate"
    hrefLang={locale}
    href={getArticleUrl(article, origin, locale)}
  />
);

export default HrefLangTag;
